import React, { createContext, useEffect, useRef, useState } from "react";
import {
	OrderInner,
	OrderPageNavigationImg,
	OrderPageNavigationInner,
	OrderPageNavigationWrap,
} from "../../Order/styled/OrderStyle";

export default function MyBookingPageNavigation() {
	return (
		<OrderInner>
			<OrderPageNavigationWrap>
				<OrderPageNavigationInner to="/">Home</OrderPageNavigationInner>
				<OrderPageNavigationImg src="./static/img/direction-right.png" />
				<OrderPageNavigationInner
					status={1}
					to="/my-booking">
					My Bookings
				</OrderPageNavigationInner>
			</OrderPageNavigationWrap>
		</OrderInner>
	);
}
